import { createSlice } from "@reduxjs/toolkit";

// export const accessPermissionSlice = createSlice({
// 	name: "accessPermissions",
// 	initialState: {
// 		accessPermissions: {
// 			// manage operator accounts
// 			operatorAccounts: "0",
// 			rolesAndTemplates: "0",
// 			accessPermission: "0",
// 			// lockers
// 			lockers: "0",
// 			lockerFees: "0",
// 			lockerStorageFees: "0",
// 			assignToBranch: "0",
// 			assignToAgent: "0",
// 			lockerCleanUp: "0",
// 			reassignPackages: "0",
// 			// locker users
// 			lockerUserAccounts: "0",
// 			lockerUserType: "0",
// 			viewPackageHistory: "0",
// 			broadcastUser: "0",
// 			// agents
// 			agents: "0",
// 			batchUpload: "0",
// 			broadcastAgents: "0",
// 			// partners
// 			partners: "0",
// 			partnerTypes: "0",
// 			branches: "0",
// 			paymentModeAndFees: "0",
// 			// settings
// 			lockerTimeLimits: "0",
// 			storageTimeLimits: "0",
// 			lockerUserTemplates: "0",
// 			courierTemplates: "0",
// 			lockerCleanupTemplates: "0",
// 			walletTopUp: "0",
// 			// campaigns
// 			behavioralCampaign: "0",
// 			// reports
// 			dropoffStatusHistory: "0",
// 			lockerOccupancy: "0",
// 			lockerFullAlerts: "0",
// 			lockerOccupancyPeakHoursReport: "0",
// 			packageDropoffPeakHoursReport: "0",
// 			staytimeInLocker: "0",
// 			partnerPerformance: "0",
// 			podReports: "0",
// 			podSummaryReport: "0",
// 			storageRentals: "0",
// 			storageFeesSummaryReport: "0",
// 			overstayFees: "0",
// 			overstayFeesReportSummary: "0",
// 			// ops report
// 			suspiciousCourier: "0",
// 			highRemovalCouriers: "0",
// 			suspiciousCourierTagging: "0",
// 			unrecognizedWaybillOPReport: "0",
// 			// redemptionCodeCampaign: "0",
// 			lockerRentals: "0",
// 			decliningUsageReport: "0",
// 			lockerClearingSummary: "0",
// 		},
// 	},
// 	reducers: {
// 		setUserAccessPermission: (state, actions) => {
// 			console.log(actions.payload);
// 			state.accessPermissions = actions.payload;
// 		},
// 	},
// });

export const accessPermissionSlice = createSlice({
	name: "accessPermissions",
	initialState: {
		accessPermissions: {
			// ... other permissions ...
		},
	},
	reducers: {
		setUserAccessPermission: (state, action) => {
			console.log({ action });
			// Check if user has admin access
			const isAdmin = action.payload.isAdmin;

			// Create new permissions object from payload
			let newPermissions = { ...action.payload };

			// If admin, override specific permissions
			if (isAdmin) {
				// Remove these permissions from consideration
				delete newPermissions.operatorAccounts;
				delete newPermissions.rolesAndTemplates;
				delete newPermissions.accessPermission;
			}

			// Update state with new permissions
			state.accessPermissions = newPermissions;
		},
	},
});

export const { setUserAccessPermission } = accessPermissionSlice.actions;

export default accessPermissionSlice.reducer;
